import api from 'common/api'

import { Message, MessageResponse } from '../types'

/** Fetch Messages */
export const getMessage = ({ scid }: { scid: number }) => {
  return api.get<MessageResponse>(`/api/college/${scid}/message`)
}

/** Priority Reordering */
export const updateMessagePriority = ({
  scid,
  message,
  priority,
}: {
  scid: number
  message: Message
  priority: number
}) => {
  return api.patch(`/api/college/${scid}/message/${message.Id}`, message, {
    ...message,
    Priority: priority,
  })
}
